import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ConjugationTable from "src/components/tables/ConjugationTable";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import PageStructure from "src/components/wrappers/PageStructure";
import ExampleTitle from "src/components/ExampleTitle";

import {
    preteritoImperfectoExplanation,
    preteritoImperfectoExamples,
    preteritoImperfectoUsageDetails,
    preteritoImperfectoDifferences,
    preteritoImperfectoRegular,
    preteritoImperfectoIrregulars,
    pastImperfectStoryPark
} from "src/data/individual-topics/PastProgressive";
import StoryCard from "src/components/cards/StoryCard";

const PreteritoImperfectoContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`${isDarkMode ? "dark" : ""}`}>
            <div className="section">
                <ExplanationCard cardData={preteritoImperfectoExplanation} />
            </div>

            <div className="section">
                <ExplanationCard cardData={preteritoImperfectoUsageDetails} />
            </div>

            <div className="section">
                <ConjugationTable tableData={{ title: "Regular Past Progressive", verbs: preteritoImperfectoRegular }} />
            </div>

            <div className="section">
                <ConjugationTable tableData={{ title: "Irregular Past Progressive", verbs: preteritoImperfectoIrregulars }} />
            </div>

            <ExampleTitle />

            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {preteritoImperfectoExamples.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <StoryCard
                story={pastImperfectStoryPark}
                title="🏞️ Una Conversación en el Parque"
            />

            <div className="section">
                <ExplanationCard cardData={preteritoImperfectoDifferences} />
            </div>
        </div>
    );
};

const PreteritoImperfectoScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Past Progressive"
            Page={<PreteritoImperfectoContent />}
        />
    );
};

export default PreteritoImperfectoScreen;
